<template>
    <div>
        <v-text-field label="ودیعه"
                      dense
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      @input="getVal($event,'credit' )"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      v-model="value.credit"
                      :maxLength="10"
                      placeholder="مقدار ودیعه را وارد کنید."
        ></v-text-field>

        <v-text-field label="اجارهٔ ماهانه"
                      dense
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      @input="getVal($event,'rent' )"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      v-model="value.rent"
                      placeholder="مقدار اجاره را وارد کنید."
        ></v-text-field>

        <v-switch v-if="!edit"
                label="قابل تبدیل"
                color="indigo"
                @input="getVal($event,'transformable' )"
                v-model="transformable"
        ></v-switch>
        <p v-if="transformable" class="text-muted pt-0">نرخ رایج مبنا برای تبدیل به ازای هر ۱ میلیون تومان ودیعه، ۳۰
            هزار
            تومان اجاره است.</p>

        <v-text-field v-if="transformable" label="تبدیل مبلغ ودیعه"
                      dense
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      @input="getVal($event,'transformed_credit' )"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      :maxLength="10"
                      placeholder="مقدار ودیعه را وارد کنید."
        ></v-text-field>

        <v-text-field v-if="transformable" label="تبدیل مبلغ اجارهٔ ماهانه"
                      dense
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      @input="getVal($event,name,'transformed_rent' )"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      :maxLength="10"
                      placeholder="مقدار  مبلغ اجارهٔ ماهانه را وارد کنید."
        ></v-text-field>
    </div>
</template>

<script>

import {Bus} from "../../../../main";

export default {
    name: "forRent",
    props: {
        value: {
            type: Object,
            default() {
                return {
                    "credit": undefined,
                    "rent": undefined,
                    "transformed_credit": undefined,
                    "transformed_rent": undefined,
                    'transformable': false
                }
            }
        },
        edit: {
            required:true,
            default:false
        }
    },
    data() {
        return {
            transformable: false
        }
    },
    methods: {
        getVal(value, type) {
            this.value[type] = parseInt(value) || undefined
        }
    },
    watch: {
        values: {
            deep: true,
            handler(value) {
                Bus.$emit('rents', value);
            }
        },
        transformable(val) {
            this.value['transformable'] = val
        }
    },
}
</script>

<style scoped>

</style>